document.addEventListener('DOMContentLoaded', function() {
  
  // MOVIMENTO 3D DEL MODULO SOLO SU COMPUTER
  const terminalWrap = document.querySelector('.koji-contact-form-col');
  const terminalGlass = document.getElementById('koji-terminal-3d');

  if (terminalWrap && terminalGlass && window.innerWidth > 990) {
    terminalWrap.addEventListener('mousemove', (e) => {
      const rect = terminalWrap.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      
      const centerX = rect.width / 2;
      const centerY = rect.height / 2;
      
      const rotateX = ((y - centerY) / centerY) * -8;
      const rotateY = ((x - centerX) / centerX) * 8;
      
      terminalGlass.style.transform = `rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
    });

    terminalWrap.addEventListener('mouseleave', () => {
      terminalGlass.style.transform = `rotateX(0deg) rotateY(0deg)`;
    });
  }

  // EFFETTO SPECIALE SUL TESTO DEL PULSANTE
  const submitBtn = document.querySelector('.koji-submit-btn');
  const submitText = document.querySelector('.koji-submit-text');
  
  if (submitBtn && submitText) {
    const originalText = submitText.textContent;
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789@#$%&*";
    let interval = null;

    submitBtn.addEventListener('mouseenter', () => {
      let iteration = 0;
      clearInterval(interval);
      
      interval = setInterval(() => {
        submitText.textContent = originalText.split('')
          .map((letter, index) => {
            if(index < iteration) { return originalText[index]; }
            return chars[Math.floor(Math.random() * chars.length)];
          })
          .join('');
        
        if(iteration >= originalText.length){ 
          clearInterval(interval);
        }
        iteration += 1 / 3; 
      }, 30);
    });

    submitBtn.addEventListener('mouseleave', () => {
      clearInterval(interval);
      submitText.textContent = originalText;
    });
  }

});